import { tokens } from "../../theme";
import * as React from "react";

import { Box, Typography, useTheme } from "@mui/material";
import GreetingHeader from "../../components/GreetingHeader";
import SectionHeader from "../../components/SectionHeader";
import Grid from "@mui/material/Unstable_Grid2"; // Grid version 2
import Stack from "@mui/material/Stack";

import ConnectionStatus from "../../utils/ConnectionStatus";
import { SnackbarProvider, useSnackbar } from "notistack";
import UseOnlineStatus from "../../utils/UseOnlineStatus";
import {
  getFromLocalStorage,
} from "../../utils/localStorageUtils";
import CustomProgressDialog from "../../components/CustomProgressDialog";
import ShowErrorAlertDialog from "../../components/ErrorAlertDialog";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAtom } from "jotai";
import {
  isAuthPageAtom,
  dialogStatus,
} from "../../config/AppConfig";
import {
  ALERT,
  ERROR,
  ERROR_FOUND_DURING_API_CALL,
  ERROR_WHILE_FETCHING_DATA,
  LOADING_PLEASE_WAIT,
  NO_INTERNET_CONNECTION_FOUND,
  PROCESSING_PLEASE_WAIT,
  SOME_ERROR_OCCURRED,
  YOU_ARE_OFFLINE,
  YOU_ARE_ONLINE,
} from "../../constants/Strings";
import { initializeEncryption } from "../../services/AesGcmEncryption";
import DebugLog from "../../utils/DebugLog";
import {
  LOGIN_ID,
  MESSAGE_KEY,
  SESSION_ID,
  USER_NAME,
} from "../../constants/LocalStorageKeyValuePairString";
import {
  generateRandomId,
  generateRequestId,
} from "../../utils/RequestIdGenerator";
import { ApiErrorCode, ApiType } from "../../services/ApiTags";
import {
  addExclusionReports,
  downloadCreditDebitAccounttReports,
  getExclusionAuditActivityDetails,
  getExclusionReports,
  getRemovedItems,
  removeExclusionForAdjustment,
  removeExclusionReports,
} from "../../services/ApiService";

import { saveAs } from "file-saver";
import isEmptyArray from "lodash/isEmpty";
import { DataGrid } from "@mui/x-data-grid";

import * as CONSTANT from "../../constants/Constant";
import {
  exclusionColumnHeader,
} from "../../components/ColumnHeader";
import NoDataFound from "../../components/NoDataFound";
import CustomButton from "../../components/CustomButton";
import { FileDialog } from "../onhold/ActionConfirmationDialog";
import DownloadDropdownButton from "../../components/DownloadDropdownButton";
import UserActivityInfoExclusionPage from "./UserActivityExclusionPage";
import CustomDatePickerDialog from "../../components/DatePickerDialog";
import AddExclusionDialog from "./AddExclusionDialog";
import { AuthContext } from "../../context/AuthContext";

const ExclusionScreen = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const isNetworkConnectionAvailable = UseOnlineStatus();
  const [selectedRows, setSelectedRows] = React.useState([]);
  const [selectedRemovedExclusionRows, setRemovedExclusionSelectedRows] =
    React.useState([]);

  const navigate = useNavigate();
  const [, setAuthStatus] = useAtom(isAuthPageAtom);
  const [getDialogStatus, setErrorDialog] = useAtom(dialogStatus);
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const [title, setTitle] = useState(ALERT);
  const [content, setContent] = useState("");
  const [, setError] = useState("");
  const [getProgressbarText, setProgressbarText] = useState("");
  const [exclusionList, setExclusionList] = useState([]);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [exclusionDialogOpen, setAddExclusionDialogOpen] = useState(false);


  const [open, setOpen] = useState(false);
  const [selectedFromDate, setSelectedFromDate] = useState("");
  const [selectedToDate, setSelectedToDate] = useState("");

  // pagination for Activity
  const [activityPageSize, setActivityPageSize] = useState(15);
  const [activityCurrentPage, setActivityCurrentPage] = useState(0);
  const [activityTotalNoOfPages, setActivityTotalNoOfPages] = useState(0);

  const [downloadButtonVisible, setDownlaodButton] = useState(false);
  const [addAddNewVisible, setAddNewButton] = useState(false);
  const [removeVisible, setRemoveButton] = useState(false);
  const [editAllowed, setEditAllowed] = useState(false);
  const [addAdjsutment, setAddAdjustment] = useState(false);

  const [paginationModel, setPaginationModel] = useState({
    pageSize: 15,
    page: 0,
  });
  // pagination
  const [currentPage, setCurrentPage] = useState(0);

  const [pageSize, setPageSize] = useState(15);
  const [totalNoOfRows, setTotalNoOfRows] = useState(0);
  const [totalNoOfPages, setTotalNoOfPages] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(0); // Used to set the height of the grid

  const [exclusionListRemovedItems, setExclusionListRemovedItems] = useState(
    []
  );

  const [paginationRemovedItemsModel, setPaginationRemovedItemsModel] =
    useState({
      pageSize: 15,
      page: 0,
    });
  // pagination
  const [currentPageRemovedItems, setCurrentPageRemovedItems] = useState(0);

  const [pageSizeRemovedItems, setPageSizeRemovedItems] = useState(15);
  const [totalNoOfRowsRemovedItems, setTotalNoOfRowsRemovedItems] = useState(0);
  const [totalNoOfPagesRemovedItems, setTotalNoOfPagesRemovedItems] =
    useState(0);
  const [rowsPerPageRemovedItems, setRowsPerPageRemovedItems] = useState(0); // Used to set the height of the grid

  const [clickedButtonType, setClickedButtonType] = useState("");
  const [dialogTitle, setDialogTitle] = useState("");
  const [selectedDate, setSelectedDate] = useState("");
  const [exclusionAuditActivity, setExclusionAuditActivity] = useState("");
  const [selectedDateRange, setSelectedDateRange] = useState(
    CONSTANT.ACTIVITY_PERIODS.THREE_MONTHS
  );
  const [gridHeight, setGridHeight] = useState(500); // Default height

   // user context
   const { authDetails } = React.useContext(AuthContext);

  useEffect(() => {

    getExclusionReport(paginationModel.page, paginationModel.pageSize);

    getExclusionReportRemovedItems(
      paginationRemovedItemsModel.page,
      paginationRemovedItemsModel.pageSize
    );

    getExclusionActivityAuditDetails(activityCurrentPage, selectedDateRange);

    updateButtonVisibility();
    
  }, []);

  useEffect(() => {
    getDataGridHeight();

    showNoInternetSnackBar();

    navigate(blockNavigation);
  }, [isNetworkConnectionAvailable, enqueueSnackbar]);

  // increase - decrease list layout height on available list itmes count
  function getDataGridHeight() {
    // Calculate the total height required for the grid
    const headerHeight = 10; // Height of header row
    const rowHeight = 60; // Height of each data row
    let rowCount = 0;
    if (totalNoOfRows <= pageSize) {
      rowCount = totalNoOfRows; // Total number of data rows
    } else {
      rowCount = pageSize; // Total number of data rows
    }

    const totalHeight = headerHeight + rowCount * rowHeight;

    // Set the grid height
    setGridHeight(totalHeight);
  }

  const handleClose = () => {
    setOpen(false);
    DebugLog("Dialog Closed");
  };

  const handleDateSelect = (date) => {
    setSelectedDate(date);
    DebugLog("Selected Date " + selectedDate);
  };


  const handleDateRangeChange = (selectedDateRange) => {
    setSelectedDateRange(selectedDateRange);
    getExclusionActivityAuditDetails(activityCurrentPage, selectedDateRange);
  };
  const updateButtonVisibility = () => {
   
    try {
      if (authDetails.sessionId !== "") {
        const userDetails =  authDetails.userAccessDetails.menuList;

        let adjustments = [];

        if (!isEmptyArray(userDetails)) {
          let menuListSize = userDetails.length;
          if (menuListSize != null && menuListSize > 0) {
            userDetails.forEach((item, index) => {
              if (item.menuListName === "Incentive") {
                adjustments = [...item.menuItem];
              }
            });

            adjustments.forEach((itemA, index) => {
              if (itemA.menuName === "Exclusions") {
                const actionButtonList = [...itemA.actionButton];
                
                actionButtonList.forEach((items, index) => {
                  if (items.buttonName === "DOWNLOAD") {
                    setDownlaodButton(true);
                  } else if (items.buttonName === "ADD NEW") {
                    setAddNewButton(true);
                  } else if (items.buttonName === "REMOVE") {
                    setRemoveButton(true);
                  } else if (items.buttonName === "EDIT") {
                    setEditAllowed(true);
                  } else if (items.buttonName === "ADD ADJUSTMENT") {
                    setAddAdjustment(true);
                  }
                });
              }
            });
          }
        }
      }
    } catch (error) {
      DebugLog(error);
    }
  };

  const handlePageSizeChange = (newPageSize) => {
    // keep pageSize in sync with the paginationModel
    setPageSize(newPageSize);
    setPaginationModel({ pageSize: newPageSize, page: 0 });

    // call api with new page size and start from page 0.
    getExclusionReport(0, newPageSize);
  };
  const handleRemovedItemsPageSizeChange = (newPageSize) => {
    // keep pageSize in sync with the paginationModel
    setPageSizeRemovedItems(newPageSize);
    setPaginationRemovedItemsModel({ pageSize: newPageSize, page: 0 });

    // call api with new page size and start from page 0.
    getExclusionReportRemovedItems(0, newPageSize);
  };

  const handleSelectionChange = (newSelection) => {
    setSelectedRows(newSelection);
  };

  const handleRemovedExclusionSelectionChange = (newSelection) => {
    setRemovedExclusionSelectedRows(newSelection);
  };
  /********  Pagination Methods ***********/
  const handlePageJump = (event) => {
    const newPage = parseInt(event.target.value, 10) - 1;
    setPaginationModel({ pageSize: pageSize, page: newPage });

    getExclusionReport(newPage, paginationModel.pageSize);
  };

  const handlePageJumpRemovedItems = (event) => {
    const newPage = parseInt(event.target.value, 10) - 1;
    setPaginationRemovedItemsModel({ pageSize: pageSize, page: newPage });

    getExclusionReportRemovedItems(
      newPage,
      paginationRemovedItemsModel.pageSize
    );
  };

  const handlePageChange = (newPage) => {
    setPaginationModel({ pageSize: pageSize, page: newPage });
    getExclusionReport(newPage, paginationModel.pageSize);
  };

  const handleRemovedItemsPageChange = (newPage) => {
    setPaginationRemovedItemsModel({ pageSize: pageSize, page: newPage });
    getExclusionReportRemovedItems(
      newPage,
      paginationRemovedItemsModel.pageSize
    );
  };

  const handleRowClick = (params) => {
    // if (params.row.isEditable !== false) {
    //   //if (editAllowed === true) {
    //   navigate(CONSTANT.ADD_ADJUSTMENTS_ROUTE, {
    //     state: { data: params.row, type: "0" },
    //   });
    //   // }
    // }
  };

  const handleRemovedItemsRowClick = (params) => {
    //if (params.row.isEditable !== false) {
    //if (editAllowed === true) {
    navigate(CONSTANT.REMOVED_EXCLUSION_TRANSACTION_TYPE_ROUTE, {
      state: { data: params.row, type: "0" },
    });
    // }
    // }
  };

  const handleActivityPageChange = (newPage) => {
    setActivityCurrentPage(newPage);
    getExclusionActivityAuditDetails(newPage, selectedDateRange);
  };

  function getExclusionActivityAuditDetails(pageNo, passedDateRange) {
    try {
      if (isNetworkConnectionAvailable) {
        setProgressbarText(LOADING_PLEASE_WAIT);
        setLoading(true);

        const toDate = new Date();
        let fromDate = new Date();

        switch (passedDateRange) {
          case CONSTANT.ACTIVITY_PERIODS.THREE_MONTHS:
            fromDate.setMonth(toDate.getMonth() - 3);
            break;
          case CONSTANT.ACTIVITY_PERIODS.SIX_MONTHS:
            fromDate.setMonth(toDate.getMonth() - 6);
            break;
          case CONSTANT.ACTIVITY_PERIODS.ONE_YEAR:
            fromDate.setFullYear(toDate.getFullYear() - 1);
            break;
          default:
            fromDate.setMonth(toDate.getMonth() - 3); // default to 3 months if no valid option is selected
        }

        const requestObject = {
          pageNumber: pageNo,
          pageSize: activityPageSize,
          //fromDate: fromDate.toISOString(),
          //toDate: toDate.toISOString(),
        };

        initializeEncryption(
          requestObject,
          getFromLocalStorage(MESSAGE_KEY),
          ApiType.GET_EXCLUSION_ACTIVITY_DETAILS
        ).then((encryptedContentData) => {
          const requestData = {
            requestId: generateRequestId(),
            loginId: getFromLocalStorage(LOGIN_ID),
            sessionId: getFromLocalStorage(SESSION_ID),
            loginUserName: getFromLocalStorage(USER_NAME),
            contentData: encryptedContentData,
          };

          getExclusionAuditActivityDetails(requestData)
            .then((response) => {
              setExclusionAuditActivity(
                response.data.result.exclusionActivityListPage.content
              );
              setActivityTotalNoOfPages(
                response.data.result.exclusionActivityListPage.totalPages
              );
              setLoading(false);
            })
            .catch((error) => {
              handleError(error);
            });
        });
      } else {
        showErrorAlert(ALERT, NO_INTERNET_CONNECTION_FOUND);
      }
    } catch (error) {
      handleError(error);
    }
  }
  function downloadExclusionData(fileType) {
    try {
      if (isNetworkConnectionAvailable) {
        setProgressbarText(LOADING_PLEASE_WAIT);
        setLoading(true);

        const requestObject = {

          reportTemplate: "ADJUSTMENT_REPORT",
          reportFormat: fileType,
        };

        initializeEncryption(
          requestObject,
          getFromLocalStorage(MESSAGE_KEY),
          ApiType.CREDIT_DEBIT_REPORT_DOWNLOAD
        ).then((encryptedContentData) => {
          const requestData = {
            requestId: generateRequestId(),
            loginId: getFromLocalStorage(LOGIN_ID),
            sessionId: getFromLocalStorage(SESSION_ID),
            loginUserName: getFromLocalStorage(USER_NAME),
            contentData: encryptedContentData,
          };

          downloadCreditDebitAccounttReports(requestData)
            .then((response) => {
              setLoading(false);


              let blob;
              const currentDate = new Date();
              const day = String(currentDate.getDate()).padStart(2, "0");
              const month = String(currentDate.getMonth() + 1).padStart(2, "0");
              const year = String(currentDate.getFullYear());

              // let filename be "EarmarkReport_YYYY-MM-DD"
              let filename = `ExclusionReport_${year}-${month}-${day}`;
              switch (fileType) {
                case "CSV":
                  blob = new Blob([response.data], { type: "text/csv" });
                  filename = filename + ".csv";
                  break;
                case "XLS":
                  blob = new Blob([response.data], {
                    type: "application/vnd.ms-excel",
                  });
                  filename = filename + ".xls";
                  break;
                case "PDF":
                  blob = new Blob([response.data], { type: "application/pdf" });
                  filename = filename + ".pdf";
                  break;

                default:
                  throw new Error("Invalid file type");
              }

              // Use FileSaver to save the file
              saveAs(blob, filename);
            })
            .catch((error) => {
              handleError(error);
            });
        });
      } else {
        showErrorAlert(ALERT, NO_INTERNET_CONNECTION_FOUND);
      }
    } catch (error) {
      handleError(error);
    }
  }
  function handleError(error) {
    setLoading(false);

    if (error.message === NO_INTERNET_CONNECTION_FOUND) {
      // Handle no internet connection error
      showErrorAlert(ALERT, NO_INTERNET_CONNECTION_FOUND);
      return;
    }

    const errorCode = error.data?.errorCode;
    var errorMessage =
      error.response != null ? error.displayErrorMessage : "Unknown";
    if (error.data?.displayErrorMessage) {
      errorMessage = error.data.displayErrorMessage;
    }

    const errorActions = {
      [ApiErrorCode.SESSION_EXPIRED]: () => navigate(CONSTANT.LOGIN),
      [ApiErrorCode.SESSION_ID_NOT_FOUND]: () => navigate("/"),

      default: () =>
        showErrorAlert(
          error.message,
          ERROR_WHILE_FETCHING_DATA + JSON.stringify(errorMessage)
        ),
    };

    (errorActions[errorCode] || errorActions.default)();
  }
  function blockNavigation(location, action) {
    // Block navigation if action is "pop", which indicates back/forward button press
    if (action === "pop") {
      // Optionally, you can show a message to the user before blocking navigation
      alert("Back button is disabled.");
      return false;
    }
    return true; // Allow navigation for other actions like "push" or "replace"
  }

  async function getExclusionReport(pageNo, pageSize) {
    try {
      if (isNetworkConnectionAvailable) {
        setProgressbarText(PROCESSING_PLEASE_WAIT);
        setLoading(true); // Hide the progress dialog

        // const id = "1";
        // const pageNumber = 1;
        // const pageSize = 10;

        const payoutDetails = {
          //id: id,
          pageNumber: pageNo,
          pageSize: pageSize,
        };

        initializeEncryption(
          payoutDetails,
          getFromLocalStorage(MESSAGE_KEY),
          ApiType.GET_EXCLUSION_ITEMS_DETAILS
        ).then((encryptedContentData) => {
          const exclusionListRequestData = {
            requestId: generateRequestId(),
            loginId: getFromLocalStorage(LOGIN_ID),
            sessionId: getFromLocalStorage(SESSION_ID),
            contentData: encryptedContentData,
            loginUserName: getFromLocalStorage(USER_NAME),
          };

          getExclusionReports(exclusionListRequestData)
            .then((response) => {
              const rowsWithIds =
                response.data.result.exclusionList.content.map((row) => ({
                  ...row,
                  id: generateRandomId(),
                }));
              setExclusionList(rowsWithIds);

              setRowsPerPage(response.data.result.exclusionList.content.length);
              setTotalNoOfRows(
                response.data.result.exclusionList.totalElements
              );
              setTotalNoOfPages(response.data.result.exclusionList.totalPages);

              setLoading(false);
            })
            .catch((error) => {
              if (error.data.errorCode === ApiErrorCode.SESSION_EXPIRED) {
                navigate(CONSTANT.LOGIN)
              }
             else 
              if (error.errorCode === ApiErrorCode.SESSION_ID_NOT_FOUND) {
                try {
                  navigate("/");
                } catch (error) {
                  DebugLog("error " + error);
                }
              } else {
                const message =
                  error.data != null
                    ? error.data.displayErrorMessage
                    : SOME_ERROR_OCCURRED;

                if (message)
                  showErrorAlert(
                    ERROR,
                    ERROR_WHILE_FETCHING_DATA + JSON.stringify(message)
                  );
              }
            });
        });
      } else {
        showErrorAlert(ALERT, NO_INTERNET_CONNECTION_FOUND);
      }
    } catch (error) {
      const message = error.response != null ? error.response : error.message;
      showErrorAlert(
        error.message,
        ERROR_FOUND_DURING_API_CALL + JSON.stringify(message)
      );
    }
  }

  async function getExclusionReportRemovedItems(pageNo, pageSize) {
    try {
      if (isNetworkConnectionAvailable) {
        setProgressbarText(PROCESSING_PLEASE_WAIT);
        setLoading(true); // Hide the progress dialog

        // const id = "1";
        // const pageNumber = 1;
        // const pageSize = 10;

        const payoutDetails = {
          //id: id,
          pageNumber: pageNo,
          pageSize: pageSize,
        };

        initializeEncryption(
          payoutDetails,
          getFromLocalStorage(MESSAGE_KEY),
          ApiType.GET_EXCLUSION_ITEMS_DETAILS
        ).then((encryptedContentData) => {
          const exclusionListRequestData = {
            requestId: generateRequestId(),
            loginId: getFromLocalStorage(LOGIN_ID),
            sessionId: getFromLocalStorage(SESSION_ID),
            contentData: encryptedContentData,
            loginUserName: getFromLocalStorage(USER_NAME),
          };

          getRemovedItems(exclusionListRequestData)
            .then((response) => {
              const rowsWithIds =
                response.data.result.exclusionRemovalList.content.map(
                  (row) => ({
                    ...row,
                    id: generateRandomId(),
                  })
                );
              setExclusionListRemovedItems(rowsWithIds);

              setRowsPerPageRemovedItems(
                response.data.result.exclusionRemovalList.content.length
              );
              setTotalNoOfRowsRemovedItems(
                response.data.result.exclusionRemovalList.totalElements
              );
              setTotalNoOfPagesRemovedItems(
                response.data.result.exclusionRemovalList.totalPages
              );

              setLoading(false);
            })
            .catch((error) => {
              if (error.data.errorCode === ApiErrorCode.SESSION_EXPIRED) {
                navigate(CONSTANT.LOGIN)
              }
             else 
              if (error.errorCode === ApiErrorCode.SESSION_ID_NOT_FOUND) {
                try {
                  navigate("/");
                } catch (error) {
                  DebugLog("error " + error);
                }
              } else {
                const message =
                error.data != null
                  ? error.data.displayErrorMessage
                  : SOME_ERROR_OCCURRED;

              if (message)
                showErrorAlert(
                  ERROR,
                  ERROR_WHILE_FETCHING_DATA + JSON.stringify(message)
                );
              }
            });
        });
      } else {
        showErrorAlert(ALERT, NO_INTERNET_CONNECTION_FOUND);
      }
    } catch (error) {
      const message = error.response != null ? error.response : error.message;
      showErrorAlert(
        error.message,
        ERROR_FOUND_DURING_API_CALL + JSON.stringify(message)
      );
    }
  }

  async function addAdjustment() {
    if(selectedRemovedExclusionRows.length===0) {
       alert("Please choose a rows first")
     } else  if(selectedRemovedExclusionRows.length >1 ) {
      alert("Please choose only one row")
     } else {
      const selectedID = selectedRemovedExclusionRows[0]
     
      const selectedIdArray = [];
      for(let i=0;exclusionListRemovedItems.length;i++) {
          if(selectedID===exclusionListRemovedItems[i].id){
            selectedIdArray.push(exclusionListRemovedItems[i].removeExclusionDetailsId) 
            break
          }
      }
     
      removeExclusionForAdjustmentAPI(selectedIdArray);
    }
  
   
  }

  async function removeExclusionForAdjustmentAPI(selectedRows) {
    try {
      if (isNetworkConnectionAvailable) {
        setProgressbarText(PROCESSING_PLEASE_WAIT);
        setLoading(true); // Hide the progress dialog

        const requestData = {
          removeExclusionDetailsId: selectedRows,
        };

        initializeEncryption(
          requestData,
          getFromLocalStorage(MESSAGE_KEY),
          ApiType.REMOVED_EXCLUSION_FOR_ADJUSTMENT
        ).then((encryptedContentData) => {
          const requestData = {
            requestId: generateRequestId(),
            loginId: getFromLocalStorage(LOGIN_ID),
            sessionId: getFromLocalStorage(SESSION_ID),
            contentData: encryptedContentData,
            loginUserName: getFromLocalStorage(USER_NAME),
          };

          removeExclusionForAdjustment(requestData)
            .then((response) => {
             if(response.data.responseCode==="0"){

              const data = {
                id:response.data.result[0].removeExclusionDetailsId,
                name:response.data.result[0].dealerName,
                code:response.data.result[0].dealerId,
                isEditable:true,
                date:""

              }

              navigate(CONSTANT.ADD_ADJUSTMENT_TO_EXCLUSION_ROUTE, {
                state: { data: data, type: "0" },
              });
             
             }
             setLoading(false);
            })
            .catch((error) => {
              if (error.data.errorCode === ApiErrorCode.SESSION_EXPIRED) {
                navigate(CONSTANT.LOGIN)
              }
             else 
              if (error.errorCode === ApiErrorCode.SESSION_ID_NOT_FOUND) {
                try {
                  navigate("/");
                } catch (error) {
                  DebugLog("error " + error);
                }
              } else {
                const message =
                error.data != null
                  ? error.data.displayErrorMessage
                  : SOME_ERROR_OCCURRED;

              if (message)
                showErrorAlert(
                  ERROR,
                  ERROR_WHILE_FETCHING_DATA + JSON.stringify(message)
                );
              }
            });
        });
      } else {
        showErrorAlert(ALERT, NO_INTERNET_CONNECTION_FOUND);
      }
    } catch (error) {
      const message = error.response != null ? error.response : error.message;
      showErrorAlert(
        error.message,
        ERROR_FOUND_DURING_API_CALL + JSON.stringify(message)
      );
    }
  }



  
  async function addExclusion(data) {
     DebugLog("data >>>>>"+JSON.stringify(data))
    try {
      if (isNetworkConnectionAvailable) {
        setProgressbarText(PROCESSING_PLEASE_WAIT);
        setLoading(true); // Hide the progress dialog

     
        // const requestData = {
        //   billingAccountNo: "1001",
        //   customerName: "Raj Roy",
        //   exclusionStart: "2024-06-21",

        //   exclusionEnd: "2024-07-19",
        //   reason: "add new exclusion",
        //   yesId: "01297313817@yes.my",
        // };

        const requestData = {
          billingAccountNo: data.customer,
          customerName: data.yesId,
          exclusionStart: data.billingAccountNo,
          exclusionEnd: data.reason,
          reason: data.from,
          yesId: data.to,
        };

        initializeEncryption(
          requestData,
          getFromLocalStorage(MESSAGE_KEY),
          ApiType.ADD_NEW_EXCLUSION
        ).then((encryptedContentData) => {
          const addExclusionRequestData = {
            requestId: generateRequestId(),
            loginId: getFromLocalStorage(LOGIN_ID),
            sessionId: getFromLocalStorage(SESSION_ID),
            contentData: encryptedContentData,
            loginUserName: getFromLocalStorage(USER_NAME),
          };

          addExclusionReports(addExclusionRequestData)
            .then((response) => {
              if (response.data.responseCode === "0") {
                alert("New Exclusion Added");
              }

              setLoading(false);
            })
            .catch((error) => {
              if (error.data.errorCode === ApiErrorCode.SESSION_EXPIRED) {
                navigate(CONSTANT.LOGIN)
              }
             else 
              if (error.errorCode === ApiErrorCode.SESSION_ID_NOT_FOUND) {
                try {
                  navigate("/");
                } catch (error) {
                  DebugLog("error " + error);
                }
              } else {
                const message =
                  error.data != null
                    ? error.data.displayErrorMessage
                    : SOME_ERROR_OCCURRED;

                if (message)
                  showErrorAlert(
                    ERROR,
                    ERROR_WHILE_FETCHING_DATA + JSON.stringify(message)
                  );
              }
            });
        });
      } else {
        showErrorAlert(ALERT, NO_INTERNET_CONNECTION_FOUND);
      }
    } catch (error) {
      const message = error.response != null ? error.response : error.message;
      showErrorAlert(
        error.message,
        ERROR_FOUND_DURING_API_CALL + JSON.stringify(message)
      );
    }
  }
  async function removeExclusion(
    removeExclusionRequestData,
    fileBase64Encoding
  ) {
    try {
      if (isNetworkConnectionAvailable) {
        setProgressbarText(PROCESSING_PLEASE_WAIT);
        setLoading(true); // Hide the progress dialog

        // const payoutDetails = {
        //   id: selectedRows,
        //   pageNumber: pageNumber,
        //   pageSize: pageSize,
        // };

        initializeEncryption(
          removeExclusionRequestData,
          getFromLocalStorage(MESSAGE_KEY),
          ApiType.REMOVE_EXCLUSION_ITEMS
        ).then((encryptedContentData) => {
          let requestData;
          if (fileBase64Encoding !== null && fileBase64Encoding !== "") {
            requestData = {
              requestId: generateRequestId(),
              loginId: getFromLocalStorage(LOGIN_ID),
              sessionId: getFromLocalStorage(SESSION_ID),
              contentData: encryptedContentData,
              loginUserName: getFromLocalStorage(USER_NAME),
              fileContent: fileBase64Encoding,
            };
          } else {
            requestData = {
              requestId: generateRequestId(),
              loginId: getFromLocalStorage(LOGIN_ID),
              sessionId: getFromLocalStorage(SESSION_ID),
              contentData: encryptedContentData,
              loginUserName: getFromLocalStorage(USER_NAME),
            };
          }

          removeExclusionReports(requestData)
            .then((response) => {
              // setTotalNoOfRows(response.data.result.exclusionList.length);
              // setExclusionList(response.data.result.exclusionList.map(row => ({ ...row, id: generateRandomId() })));

              setLoading(false);
            })
            .catch((error) => {
              if (error.data.errorCode === ApiErrorCode.SESSION_EXPIRED) {
                navigate(CONSTANT.LOGIN)
              }
             else 
              if (error.errorCode === ApiErrorCode.SESSION_ID_NOT_FOUND) {
                try {
                  navigate("/");
                } catch (error) {
                  DebugLog("error " + error);
                }
              } else {
                const message =
                error.data != null
                  ? error.data.displayErrorMessage
                  : SOME_ERROR_OCCURRED;

              if (message)
                showErrorAlert(
                  ERROR,
                  ERROR_WHILE_FETCHING_DATA + JSON.stringify(message)
                );
              }
            });
        });
      } else {
        showErrorAlert(ALERT, NO_INTERNET_CONNECTION_FOUND);
      }
    } catch (error) {
      const message = error.response != null ? error.response : error.message;
      showErrorAlert(
        error.message,
        ERROR_FOUND_DURING_API_CALL + JSON.stringify(message)
      );
    }
  }

  const handleDialogOpen = (type) => {
    if (selectedRows.length > 0) {
      // let title = "";
      // if (type === "Cancel") {
      //   title = "Cancel";
      // } else if (type === "Release") {
      //   title = "Release";
      // } else if (type === "Remove Exclusion") {
      //   title = "Request Release";
      // }
      setClickedButtonType(type);
      setDialogTitle(type);
      setDialogOpen(true);
    } else {
      alert( "Please select some row first!");
    }
  };

 

  const handleDialogClose = () => {
    setDialogOpen(false);
  };

  

  const openAddExclusionDialog = () => {
    setAddExclusionDialogOpen(true);
  };

  const handleAddExclusionDialogClose = () => {
    setAddExclusionDialogOpen(false);
  };

  const handleSubmit = (file, comment, type) => {

    dialogResponseRecieved(file, comment, type);
  };

  const dialogResponseRecieved = (file, comment, type) => {
    const selectedData = exclusionList.filter((row) =>
      selectedRows.includes(row.id)
    );

    if (selectedData.length > 0) {
      const exclusionDetailsId = selectedData[0].exclusionDetailsId;
      //const extractVersionCode = selectedData[0].version;

      // const transactionTypes = selectedData.map((item) => item.transactionType);

      if (file) {
        const fileNameWithoutExtension = file.name
          .split(".")
          .slice(0, -1)
          .join(".");

        handleFileChange(
          file,
          exclusionDetailsId,
          fileNameWithoutExtension,
          comment,
          type
        );
      } else {
        const requestData = {
          exclusionDetailsId: exclusionDetailsId,
          comment: comment,
          //version: extractVersionCode,
          //transactionTypes: transactionTypes,
        };

        // if (type === "Cancel") {
        removeExclusion(requestData, "");
        // } else if (type === "Release") {
        //   releaseOnHoldApiRequest(requestData,"");
        // } else if (type === "Request Release") {
        //   requestReleaseOnHoldApiCall(requestData,"");
        // }
        DebugLog("onHold Request Data =======" + JSON.stringify(requestData));
      }
    } else {
      showErrorAlert("Alert", "Please choose some rows first!");
    }
  };

  const handleFileChange = async (
    selectedFile,
    extractBatchNo,
    fileNameWithoutExtension,
    comment,
    type
  ) => {
    try {
      const fileBase64Encoding = await getBase64(selectedFile);
      // Extract only the Base64 data
      const base64Only = fileBase64Encoding.split(",")[1];
      //const fileByteArray = await getByteArray(selectedFile);
      const requestData = {
        exclusionDetailsId: extractBatchNo,
        fileName: fileNameWithoutExtension,
        fileType: selectedFile.type,
        //contentBase64: "",
        remark: comment,
        //version: extractVersionCode,
        //transactionTypes: transactionTypes,
      };
      DebugLog(
        "exclusion Request Data base64 =======" + JSON.stringify(requestData)
      );

      //if (type === "Cancel") {
      removeExclusion(requestData, base64Only);
      // } else if (type === "Release") {
      //   releaseOnHoldApiRequest(requestData,base64Only);
      // } else if (type === "Request Release") {
      //   requestReleaseOnHoldApiCall(requestData,base64Only);
      // }

      // return base64String;
    } catch (error) {
      console.error("Error converting file to byte array:", error);
    }
  };

  const getByteArray = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsArrayBuffer(file);
      reader.onload = () => {
        const arrayBuffer = reader.result;
        const byteArray = new Uint8Array(arrayBuffer);
        resolve(byteArray);
      };
      reader.onerror = (error) => reject(error);
    });
  };

  const getBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };
  function showErrorAlert(title, content) {
    try {
     
      DebugLog("error.data=====" + content);
      setError();
      setLoading(false);
      setTitle(title);
      setContent(content);
     
    } catch (error) {
      DebugLog(error);
    }
  }

  useEffect(() => {
    if (content !== null && content!=="") {
      // State has been updated, perform your action here
      setErrorDialog(true);
    }
  }, [content]); // Dependency array, runs the effect when 'state' changes


  const showNoInternetSnackBar = () => {
    if (isNetworkConnectionAvailable) {
      enqueueSnackbar(YOU_ARE_ONLINE);
    } else {
      enqueueSnackbar(YOU_ARE_OFFLINE, {
        autoHideDuration: 3000,
        variant: "error",
      });
    }
  };
  return (
    /* Main Container */
    <Box>
      <SnackbarProvider maxSnack={3}>
        <ConnectionStatus />
        <ShowErrorAlertDialog
          status={getDialogStatus}
          title={title}
          content={content}
        />
        <AddExclusionDialog
          openExclusion={exclusionDialogOpen}
          closeExclusion={handleAddExclusionDialogClose}
          onSubmitExclusion={addExclusion}
        ></AddExclusionDialog>

        <FileDialog
          open={dialogOpen}
          handleClose={handleDialogClose}
          handleSubmit={handleSubmit}
          type={clickedButtonType}
          title={dialogTitle}
        />

          <CustomDatePickerDialog
            open={open}
            onClose={handleClose}
            onSelect={handleDateSelect}
            type={0}
          />
        {isNetworkConnectionAvailable ? (
          <CustomProgressDialog open={loading} text={getProgressbarText} />
        ) : (
          showNoInternetSnackBar()
        )}

        <Grid
          container
          component="main"
          direction={"column"}
          sx={{
            // height: "100vh",
            m: "0 2.5%" /* Approx 30px */,
            borderRadius: "18px",
          }}
        >
          {/* Greetings Header */}
          <Grid container>
            <Grid item>
              <GreetingHeader name={"Exclusion"}></GreetingHeader>
            </Grid>
          </Grid>
          {/* Greetings Header */}

          {/* Validations Section */}
          <Grid
            container
            mt={3}
            border={"1px solid" + colors.grey[600]}
            borderRadius={2}
            xs={12}
            sm={12}
            md={12}
            lg={12}
            xl={12}
            pb={2}
          >
            <SectionHeader
              sectionIcon={"../../assets/common/Payouts.svg"}
              sectionHeading={"Exclusion"}
            ></SectionHeader>

            {exclusionList.length > 0 ? (
              <Box
                borderRadius={3}
                flex={1}
                m="0px 0 0 0"
                pb={0}
                height={gridHeight}
                // height={400}
                sx={{
                  "& .MuiDataGrid-root": {
                    border: "none",
                  },
                  "& .MuiDataGrid-cell": {
                    borderBottom: "none",
                  },
                  "& .name-column--cell": {
                    color: colors.redAccent[200],
                    fontWeight: "bold",
                    fontSize: 13,
                  },
                  "& .MuiDataGrid-columnHeaders": {
                    backgroundColor: "rgba(255,255,255,0.6)",
                    borderBottom: "none",
                    fontWeight: "bold",
                    fontSize: "13px",
                    color: `${colors.grey[300]} !important`,
                  },
                  "& .MuiDataGrid-virtualScroller": {
                    background: "rgba(255,255,255,1)",
                  },
                  "& .MuiDataGrid-footerContainer": {
                    borderTop: "none",
                    backgroundColor: "rgba(255,255,255,0.6)",
                  },
                  "& .MuiCheckbox-root": {
                    //color: `${colors.white[200]} !important`,
                  },
                  "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
                    color: `${colors.grey[300]} !important`,
                    // backgroundColor: "rgba(255,255,255,0.6)",
                    // opacity:.5
                  },
                }}
              >
                <DataGrid
                  classes={{ row: "dataGridRow" }}
                  rows={exclusionList}
                  columns={exclusionColumnHeader}
                  // components={{ Toolbar: GridToolbar }}
                  checkboxSelection
                  selectionModel={selectedRows}
                  onSelectionModelChange={handleSelectionChange}
                  pageSize={pageSize}
                  rowCount={totalNoOfRows}
                  paginationModel={paginationModel}
                  paginationMode="server"
                  keepNonExistentRowsSelected
                  disableSelectionOnClick // Disable row selection on row click
                  onPageChange={handlePageChange}
                  onPageSizeChange={handlePageSizeChange}
                  rowsPerPageOptions={[15, 30, 45, 60]}
                  autoHeight
                  onRowClick={handleRowClick}
                />
                {/* </div> */}
              </Box>
            ) : (
              NoDataFound()
            )}
          </Grid>
          {/* Validations Section */}

          {exclusionList.length > 0 ? (
            <Box mt={15}>
              <Typography>
                <span>Jump to page: </span>
                <select value={currentPage + 1} onChange={handlePageJump}>
                  {[...Array(totalNoOfRows)].map((_, index) => (
                    <option key={index} value={index + 1}>
                      {index + 1}
                    </option>
                  ))}
                </select>
              </Typography>
            </Box>
          ) : (
            ""
          )}
        </Grid>

        {/* Action Buttons */}

        <Grid item mt={1} mr={10} justifyContent={"flex-start"} pb={10}>
          <Stack direction="row" spacing={2} justifyContent={"flex-end"}>
            {addAddNewVisible === true ? (
              <CustomButton
                btnBG={colors.grey[900]}
                btnColor={colors.grey[100]}
                btnTxt={"ADD NEW"}
                //onClick={openAddExclusionDialog}
                onClick={() => openAddExclusionDialog()}
              ></CustomButton>
            ) : (
              ""
            )}

            {exclusionList.length > 0 && removeVisible === true ? (
              <CustomButton
                btnBG={colors.grey[900]}
                btnColor={colors.grey[100]}
                btnTxt={"REMOVE"}
                //onClick={removeExclusion}
                onClick={() => handleDialogOpen("Remove Exclusion")}
              ></CustomButton>
            ) : (
              ""
            )}
            {downloadButtonVisible === true ? (
              <DownloadDropdownButton
                onFileTypeSelected={downloadExclusionData}
              />
            ) : (
              ""
            )}
          </Stack>
        </Grid>

        <Grid
          container
          component="main"
          direction={"column"}
          sx={{
            // height: "100vh",
            m: "0 2.5%" /* Approx 30px */,
            borderRadius: "18px",
          }}
        >
          {/* Greetings Header */}
          {/* <Grid container>
            <Grid item>
              <GreetingHeader name={"Exclusion"}></GreetingHeader>
            </Grid>
          </Grid> */}

          <Grid
            container
            mt={3}
            border={"1px solid" + colors.grey[600]}
            borderRadius={2}
            xs={12}
            sm={12}
            md={12}
            lg={12}
            xl={12}
            pb={2}
          >
            <SectionHeader
              sectionIcon={"../../assets/common/Payouts.svg"}
              sectionHeading={"Removed"}
            ></SectionHeader>

            {exclusionListRemovedItems.length > 0 ? (
              <Box
                borderRadius={3}
                flex={1}
                m="0px 0 0 0"
                pb={0}
                height={gridHeight}
                // height={400}
                sx={{
                  "& .MuiDataGrid-root": {
                    border: "none",
                  },
                  "& .MuiDataGrid-cell": {
                    borderBottom: "none",
                  },
                  "& .name-column--cell": {
                    color: colors.redAccent[200],
                    fontWeight: "bold",
                    fontSize: 13,
                  },
                  "& .MuiDataGrid-columnHeaders": {
                    backgroundColor: "rgba(255,255,255,0.6)",
                    borderBottom: "none",
                    fontWeight: "bold",
                    fontSize: "13px",
                    color: `${colors.grey[300]} !important`,
                  },
                  "& .MuiDataGrid-virtualScroller": {
                    background: "rgba(255,255,255,1)",
                  },
                  "& .MuiDataGrid-footerContainer": {
                    borderTop: "none",
                    backgroundColor: "rgba(255,255,255,0.6)",
                  },
                  "& .MuiCheckbox-root": {
                    //color: `${colors.white[200]} !important`,
                  },
                  "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
                    color: `${colors.grey[300]} !important`,
                    // backgroundColor: "rgba(255,255,255,0.6)",
                    // opacity:.5
                  },
                }}
              >
                <DataGrid
                  classes={{ row: "dataGridRow" }}
                  rows={exclusionListRemovedItems}
                  columns={exclusionColumnHeader}
                  // components={{ Toolbar: GridToolbar }}
                  checkboxSelection
                  selectionModel={selectedRemovedExclusionRows}
                  onSelectionModelChange={handleRemovedExclusionSelectionChange}
                  pageSize={pageSizeRemovedItems}
                  rowCount={totalNoOfRowsRemovedItems}
                  paginationModel={paginationRemovedItemsModel}
                  paginationMode="server"
                  keepNonExistentRowsSelected
                  disableSelectionOnClick // Disable row selection on row click
                  onPageChange={handleRemovedItemsPageChange}
                  onPageSizeChange={handleRemovedItemsPageSizeChange}
                  rowsPerPageOptions={[15, 30, 45, 60]}
                  autoHeight
                  onRowClick={handleRemovedItemsRowClick}
                />
                {/* </div> */}

                {exclusionListRemovedItems.length > 0 ? (
                  <Box mt={1}>
                    <Typography>
                      <span>Jump to page: </span>
                      <select
                        value={currentPageRemovedItems + 1}
                        onChange={handlePageJumpRemovedItems}
                      >
                        {[...Array(totalNoOfRowsRemovedItems)].map(
                          (_, index) => (
                            <option key={index} value={index + 1}>
                              {index + 1}
                            </option>
                          )
                        )}
                      </select>
                    </Typography>
                  </Box>
                ) : (
                  ""
                )}

               
          <Stack direction="row" spacing={2} justifyContent={"flex-end"} mr={6}>
            {addAdjsutment === true ? (
              <CustomButton
                btnBG={colors.grey[900]}
                btnColor={colors.grey[100]}
                btnTxt={"ADD ADJUSTMENT"}
                onClick={addAdjustment}  
              ></CustomButton>
            ) : (
              ""
            )}
           
            {downloadButtonVisible === true ? (
              <DownloadDropdownButton
                onFileTypeSelected={downloadExclusionData}
              />
            ) : (
              ""
            )}
          </Stack>
       
              </Box>

            
            ) : (
              NoDataFound()
            )}
          </Grid>
          {/* Validations Section */}
        

        {/* Action Buttons */}

        <Grid item mt={20} mr={10} justifyContent={"flex-start"} pb={20}>
        </Grid>

        {/* Action Buttons */}

        {/* activity list */}
        <Grid container>

          <UserActivityInfoExclusionPage
            type={"ExclusionModule"}
            data={exclusionAuditActivity}
            ondateRangeChange={handleDateRangeChange}
            totalNoOfPages={activityTotalNoOfPages}
            onPageChange={handleActivityPageChange}
          />

        </Grid>

      </Grid>  
      </SnackbarProvider>
    </Box>
    /* Main Container */
  );
};

export default ExclusionScreen;
